import ImageTileSkelton from "./ui-elements/ImageTileSkelton";

const PopularSurahSkelton=()=>{
    return(
        <div className="flex gap-0 md:gap-4">
            {Array.from({ length: 3 }).map((item, index) => (
                <div 
                className={`
                    w-full 
                    ${index === 0 ? "block" : ""}
                    ${index === 1 ? "hidden md:block" : ""}
                    ${index === 2 ? "hidden lg:block" : ""}
                  `}
                key={index}>
                    <ImageTileSkelton tileId={index+1}/>
                </div>
            ))}
        </div>
    );
}

export default PopularSurahSkelton;